import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import CollectorClaimModal from '../Claims/ClaimModal/CollectorClaimModal';
import useFetch from '../Utilities/useFetch';
import { Button, Row, Col } from 'react-bootstrap'

const ReportTemplateCSVClick = ({
    columnDefs,
    apiUrl,
    reportName
}) => {
    const [selectedDebtorId, setSelectedDebtorId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [gridApi, setGridApi] = useState();
     const { data: rowData, error } = useFetch(true, apiUrl, 'GET');
   const onBtnExport = () => {
        const textColumns = ['Claim ID','clientRefNo', 'RefNo']; // columns to format as text
        const dateColumns = ['listDate','serviceDate','arbHearingDate','accountStatusDate','depositDate','dateReceived','dateRemitted']; // columns to format as date
        gridApi.exportDataAsCsv({
        processCellCallback: (params) => {
            if (textColumns.includes(params.column.getColId())) {
                return params.value != null ? "'" + params.value : '';
            }
            if (dateColumns.includes(params.column.getColId())) {
                if (params.value == null) return '';
                const date = new Date(params.value);
                // convert to standard date string
                const formattedDate = isNaN(date.getTime()) ? '' : date.toLocaleDateString();

                return formattedDate;
            }
            return params.value;
            }
        });
    }  
  const onGridReady = (params) => {
        setGridApi(params.api);
    }

    if (error) {
        console.error('Error fetching data:', error);
    }


    const onCellClicked = (event) => {
        setSelectedDebtorId(event.data.debtorid);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div>
            <Row>
                 <Col>
                     <h4 className='margin'>{reportName}</h4>
                 {error && <div className="error-message">Error fetching data: {error.message}</div>}
                </Col>
                 <Col className='export-button'>
                     <Button variant='secondary' onClick={onBtnExport}>Download CSV</Button>
                 </Col>
 
                 </Row>
             
            
            <div className="ag-theme-quartz compact-theme grid">
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true }}
                    onCellClicked={onCellClicked}
                    onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                    onGridReady={onGridReady}

                />
            </div>
            {isModalOpen && (
                <CollectorClaimModal

                    selectedClaim={selectedDebtorId}
                    setSelectedClaim={setSelectedDebtorId}
                    onGridReady={onGridReady}
                    defaultColDef={{ sortable: true, filter: true }}
                    show={isModalOpen}
                    setShow={closeModal}
                />
            )}
        </div>
    );
};

export default ReportTemplateCSVClick;